import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation updateSkillsDirectory($id: ID!, $model: RequestTypeDirectoryInput !) {
  updateRequestTypeDirectory(id: $id, input: $model) {
    id
    name
    description
    team {
      id
      name
    }
    requestTypes {
      priority
      requestType {
        id
        name
        active
        description
      }
    }
    priority
  }
}`;

function updateSkillsDirectory(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateRequestTypeDirectory);
}

export default updateSkillsDirectory;
